import React,{useState,useEffect} from 'react'
import {Box, Heading,DataTable,Tag } from 'grommet'
import { withRouter } from 'react-router-dom';
import AccountForm from '../../../components/accountForm'
import AddCommodities from '../../../components/addCommodities'
import { API,Auth } from 'aws-amplify';
import { NavigationSnackBar,ReturnAddress,LoadLayer} from '../../../components/utils/shared/shared';
import {APIRequest} from '../../../components/utils/shared/requests'
import {ShipmentSuccessNotification} from '../../../components/utils/shared/shipmentViewFunctions'

function EditLab (props) {
  const [lab, setLab] = useState();
  const [commodities, setCommodities] = useState()
  const [load, setLoad] = useState(true); 
  const [commoditySuccess, setCommoditySuccess] = useState(false)
    useEffect(() => { 
      APIRequest(`/list_lab_commodities?lab=${props.match.params.lab_id}`).then(result =>{setCommodities(result)})
      APIRequest(`/labs/${props.match.params.lab_id}`).then(result => {setLab(result); setLoad(false)})
    },[]);

    const setOrg = () => {
      return null
    }

    const returnCommodityActive = (commodity) => {
      if (commodity.status){
        return <Box direction='row' margin='xsmall'><Tag background={{ color: 'status-ok', opacity: "strong" }} size='small' value={"Active"} /></Box>
      } else {
        return <Box direction='row' margin='xsmall'><Tag background={{ color: 'status-disabled', opacity: "strong" }} size='small' value={"Inactive"} /></Box>
      }
    }

    const handleSubmit = () => {
        setLoad(true)
        const updatedLab = ReturnAddress(lab, 'lab', 'edit')
        Auth.currentSession().then(session => {
          API
          .put("LabShip", `/labs/${lab.id}`,
          { headers: { 
            Authorization: session.idToken.jwtToken,
          }, 
          body:{lab: updatedLab}})
          .then(shipment => {
            setLoad(false)
            props.history.push({pathname:'/admin/labs/all', edit:true, labSucc: true})
         })
        })
      }
  return (
   <Box background={'light-1'}>
      {(load ? <LoadLayer load={load} label={'Loading Lab'} />: 
      <Box>
        {commoditySuccess && (<ShipmentSuccessNotification label={"Lab Commodities"} edit={true} />)}
        <NavigationSnackBar title={`${lab.name}`} user={props.user} pages={[{name: 'Dashboard',link: '/dashboard'},{name: 'Labs', link: '/labs/all'}]}  />
        <Box alignSelf='center' elevation='medium' direction='column' margin='small' round >
        <AccountForm label="Update Lab" setOrg={setOrg} value={lab} showQuote={lab.display_quote} user={props.user} account={lab} lab={lab} load={load} handleSubmit={handleSubmit} setAccount={setLab} />
        </Box>
        <Box elevation='large' margin='small' round>
        <Heading margin='small' size='small'>Commodities</Heading>
        <AddCommodities lab={lab} setCommoditySuccess={setCommoditySuccess} />
          <DataTable size='medium' margin='small' onClickRow={()=>{}} columns={[ {header:"ID",property:"id",primary:true,sortable:true,search:false}, {header:"Name",property:"name"}, {header:"Description",property:"description"}, {header:"HS Code",property:"code"},{header:"Active", render: (datum) => returnCommodityActive(datum) } ]} data={commodities} step={10} />
        </Box>
      </Box>
      )}
   </Box>
  )
}

export default withRouter(EditLab)
